import React, { useRef } from 'react';
import { func, node, bool, string } from 'prop-types';

const FileUpload = props => {
  const { onChange, disabled, children, accept } = props;
  const inputRef = useRef();

  const handleSelectedFile = async event => {
    const { files } = event.target;
    onChange(files);
    // to clear the input file
    if (inputRef.current) {
      inputRef.current.value = null;
    }
  };

  const triggerInputFile = () => {
    if (!disabled) inputRef.current.click();
  };

  return (
    <span onClick={triggerInputFile}>
      <input
        type="file"
        onChange={handleSelectedFile}
        style={{ display: 'none' }}
        ref={inputRef}
        accept={accept}
      />
      {children}
    </span>
  );
};

FileUpload.propTypes = {
  onChange: func,
  disabled: bool,
  children: node,
  accept: string,
};

FileUpload.defaultProps = {
  onChange: () => {},
  disabled: false,
  children: null,
  accept: 'image/png, image/jpeg',
};

export default FileUpload;
